import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Text } from '@uhg-abyss/web/ui/Text';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * TagHistoryTable
 *
 * Data containing categories of tags, and their respective tags.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function TagHistoryTable({ rows = [] }) {
  /**
   * renderCellStatus
   *
   * displays the color coded Status in a cell.
   *
   * @param cell
   * @returns {Element}
   */
  const renderCellStatus = ({ cell }) => {
    if (cell?.value === 'Added') {
      return (
        <Badge outline variant="success">
          Added
        </Badge>
      );
    }

    if (cell?.value === 'Removed') {
      return (
        <Badge outline variant="error">
          Removed
        </Badge>
      );
    }

    return null;
  };

  /**
   * renderCellLastModified
   *
   * Displays the changed date cell.
   *
   * @param cell
   * @returns {*}
   */
  const renderCellLastModified = ({ cell }) => {
    return dayjs(cell?.value).format('MM/DD/YYYY, HH:mm:ss');
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header === 'Last Modified') {
        column.Cell = renderCellLastModified;
      }

      if (column.Header === 'Status') {
        column.Cell = renderCellStatus;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/Tags/components/Table/Table.jsx">
      <TableComponent
        {...{
          accessor: `eidSearch-tags`,
          columns,
          configuration,
          headerLeft: <Text fontWeight="bold">Tag History</Text>,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
